module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1437202"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 815
// module chunks = 1